var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 42,
    viewBox: "0 0 54 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.82 13.52H53.36L44.59 0.0400391L35.82 13.52Z",
    fill: "#42004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.74 27.3296H44.29L35.52 13.8496L26.74 27.3296Z",
    fill: "#42004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.67 41.1402H35.22L26.44 27.6602L17.67 41.1402Z",
    fill: "#42004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15 13.48H35.7L26.92 0L18.15 13.48Z",
    fill: "#42004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.48H17.55L8.77 0L0 13.48Z",
    fill: "#42004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07001 27.2896H26.62L17.85 13.8096L9.07001 27.2896Z",
    fill: "#42004C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.36,
    height: 41.14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape-3.7302efcea9fb6aa4906ae81760ea863b.svg";
export { ForwardRef as ReactComponent };